import React, { useState } from 'react'
import { Image } from 'react-native'


const RemoteImage = ( props ) => {
	const { uri, desiredWidth } = props;
	
	const [ desiredHeight, setDesiredHeight ] = useState( 0 )
	
	const viewStyle = [
		props.style,
		{
			width: desiredWidth,
			height: desiredHeight
		}
	]
	
	Image.getSize(uri, (width, height) => {
		setDesiredHeight(desiredWidth / width * height)
	})
	
	return (
		<Image
			{ ...props }
			source={{ uri }}
			style={ viewStyle }
		/>
	)
}

export default RemoteImage
